const initialState = {
	isLoading: false,
	list: [],
	totalsize: 0,
};

function tiktokFirstSalesReducer(state = initialState, action) {
	switch (action.type) {
		case 'LOADING_TIKTOK_FIRST_SALES':
			return {
				...state,
				isLoading: action?.payload
			};
		case 'ADMIN_TIKTOK_FIRST_SALES':
			return {
				...state,
				list: action?.payload?.product_first_sale || [],
				totalsize: action?.payload?.totalsize || 0
			};
		default:
			return state;
	}
}

export default tiktokFirstSalesReducer;
